import { number } from '@/common/utils/filters'
import i18n from '@/application/i18n/i18n'

import volumeSelectionIcon0 from '@/features/onboarding-wizard/assets/volume-selection-0.svg'
import volumeSelectionIcon0to10 from '@/features/onboarding-wizard/assets/volume-selection-0-10.svg'
import volumeSelectionIcon10to50 from '@/features/onboarding-wizard/assets/volume-selection-10-50.svg'
import volumeSelectionIcon50to400 from '@/features/onboarding-wizard/assets/volume-selection-50-400.svg'
import volumeSelectionIcon400to1000 from '@/features/onboarding-wizard/assets/volume-selection-400-1000.svg'
import volumeSelectionIcon1000to2500 from '@/features/onboarding-wizard/assets/volume-selection-1000-2500.svg'
import volumeSelectionIcon2500to20000 from '@/features/onboarding-wizard/assets/volume-selection-2500-20000.svg'
import volumeSelectionIcon20000plus from '@/features/onboarding-wizard/assets/volume-selection-20000plus.svg'

export const VOLUME_BUCKETS = () => ([
  {
    id: 'not_shipping',
    label: i18n.t('onboarding_wizard.your_details.volume.not_shipping'),
    icon: volumeSelectionIcon0,
    lowestVolume: -1,
    eventName: 'Volume Selected Bucket 0',
  },
  {
    id: '0-10',
    label: `0 - 10 ` + i18n.t('per month'),
    icon: volumeSelectionIcon0to10,
    lowestVolume: 0,
    eventName: 'Volume Selected Bucket 1',
  },
  {
    id: '10-50',
    label: `10 - 50 ` + i18n.t('per month'),
    icon: volumeSelectionIcon10to50,
    lowestVolume: 10,
    eventName: 'Volume Selected Bucket 2',
  },
  {
    id: '50-400',
    label: `50 - 400 ` + i18n.t('per month'),
    icon: volumeSelectionIcon50to400,
    lowestVolume: 50,
    eventName: 'Volume Selected Bucket 3',
  },
  {
    id: '400-1000',
    label: `400 - ${number(1000, 0)} ` + i18n.t('per month'),
    icon: volumeSelectionIcon400to1000,
    lowestVolume: 400,
    eventName: 'Volume Selected Bucket 4',
  },
  {
    id: '1000-2500',
    label: `${number(1000, 0)} - ${number(2500, 0)} ` + i18n.t('per month'),
    icon: volumeSelectionIcon1000to2500,
    lowestVolume: 1000,
    eventName: 'Volume Selected Bucket 5',
  },
  {
    id: '2500-30000',
    label: `${number(2500, 0)} - ${number(30000, 0)} ` + i18n.t('per month'),
    icon: volumeSelectionIcon2500to20000,
    lowestVolume: 2500,
    eventName: 'Volume Selected Bucket 6',
  },
  {
    id: '30000-100000',
    label: `${number(30000, 0)} - ${number(100000, 0)}+ ` + i18n.t('per month'),
    icon: volumeSelectionIcon20000plus,
    lowestVolume: 30000,
    eventName: 'Volume Selected Bucket 7',
  },
])

export const INDUSTRIES = () => ([
  {
    id: 'toys-games-entertainment',
    name: i18n.t('Toys & Games, Entertainment'),
  },
  {
    id: 'sports-recreation',
    name: i18n.t('Sports & Recreation'),
  },
  {
    id: 'clothing-fashion',
    name: i18n.t('Clothing & Fashion'),
  },
  {
    id: 'jewelry-accessories',
    name: i18n.t('Jewelry & Accessories'),
  },
  {
    id: 'foods-drinks',
    name: i18n.t('Food & Drinks'),
  },
  {
    id: 'home-garden-diy',
    name: i18n.t('Home, Garden, DIY'),
  },
  {
    id: 'furniture-decoration',
    name: i18n.t('Furniture & Decoration'),
  },
  {
    id: 'animals-pets',
    name: i18n.t('Animals & Pets'),
  },
  {
    id: 'education-books',
    name: i18n.t('Education & Books'),
  },
  {
    id: 'office-supplies',
    name: i18n.t('Office supplies'),
  },
  {
    id: 'electronics',
    name: i18n.t('Electronics'),
  },
  {
    id: 'car-motor',
    name: i18n.t('Car & Motor'),
  },
  {
    id: 'health-beauty',
    name: i18n.t('Health & Beauty'),
  },
  {
    id: 'baby-toddler',
    name: i18n.t('Baby & Toddler'),
  },
  {
    id: 'fulfillment',
    name: i18n.t('Fulfilment'),
  },
  {
    id: 'marketplace',
    name: i18n.t('Marketplace'),
  },
  {
    id: 'logistics-service-provider',
    name: i18n.t('Logistics service provider'),
  },
  {
    id: 'other',
    name: i18n.t('Other'),
  },
])

export const ADDRESS_FORM_OW_EXPERIMENT_ID = 'address_form_business_details_new_layout'

export const COUNTRIES_TOP_CARRIERS = {
  NL: [
    'POSTNL',
    'DPD',
    'DHL',
    'GLS_NL',
    'UPS',
    'FEDEX',
    'DHL_EXPRESS',
    'MONDIAL_RELAY',
    'BOL',
    'DEUTSCHE_POST',
    'TRUNKRS',
    'BUDBEE',
    'FIETSKOERIERS',
    'VIATIM',
    'EUROPAKET',
    'SPRING',
    'BRING',
    'ASENDIA',
  ],
  BE: [
    'DPD',
    'POSTNL',
    'TRANSFORCE',
    'BPOST',
    'FEDEX',
    'MONDIAL_RELAY',
    'GLS_DE',
    'DHL',
    'DHL_EXPRESS',
    'UPS',
  ],
  DE: [
    'DHL_DE',
    'DPD',
    'GLS_DE',
    'HERMES_DE',
    'UPS',
    'FEDEX',
    'DHL_EXPRESS',
    'DEUTSCHE_POST',
    'QUICARGO',
  ],
  FR: [
    'COLISSIMO',
    'MONDIAL_RELAY',
    'CHRONOPOST',
    'DPD_FR',
    'LETTRESUIVIE',
    'GLS_DE',
    'AMAZON',
    'DHL_EXPRESS',
    'UPS',
    'FEDEX',
    'GEODIS',
    'DEUTSCHE_POST',
    'DELIVENGO',
    'COLISPRIVE',
    'SPRING',
  ],
  ES: [
    'CORREOS',
    'CORREOS_EXPRESS',
    'SEUR',
    'CTT_EXPRESS',
    'UPS',
    'FEDEX',
    'INPOST_ES',
    'DHL_EXPRESS',
    'DHL_PARCEL_IBERIA',
    'NACEX',
    'TIPSA',
    'GLS_ES',
    'MRW',
    'SPRING',
  ],
  AT: [
    'POSTAT',
    'DPD_AT',
    'GLS_DE',
    'DHL',
    'DHL_EXPRESS',
    'HERMES_AT',
    'UPS',
    'FEDEX',
  ],
  IT: [
    'BRT',
    'INPOST_IT',
    'GLS_IT',
    'POSTE_IT_DELIVERY',
    'FEDEX',
    'DPD',
    'DHL',
    'UPS',
    'TNT_IT',
    'AMAZON',
  ],
  GB: [
    'HERMES_GB',
    'ROYAL_MAIL',
    'DPD_GB',
    'DHL_PARCEL_GB',
    'FEDEX',
    'MHI',
    'UPS',
    'PARCELFORCE',
  ],
}
